module.exports = __webpack_public_path__ + "img/australia-tuberculosis-female.8886ec23.png";